import { render, staticRenderFns } from "./TelReleaseStatusChart.vue?vue&type=template&id=47d92508"
import script from "./TelReleaseStatusChart.vue?vue&type=script&lang=js"
export * from "./TelReleaseStatusChart.vue?vue&type=script&lang=js"
import style0 from "./TelReleaseStatusChart.vue?vue&type=style&index=0&id=47d92508&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports